import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=7b79f212&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=ts&"
export * from "./Album.vue?vue&type=script&lang=ts&"
import style0 from "./Album.vue?vue&type=style&index=0&id=7b79f212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79f212",
  null
  
)

export default component.exports